/* GENERATED FILE — DO NOT EDIT.
 *
 * F15 step 2 (born linked): the published catalogue the web links against — the phone's own seed,
 * `HybridTrainer/Services/ExerciseCatalogSeed.swift` — and a CORPUS of names with the verdict `CatalogLink.resolve` (Swift) gives each.
 * `catalogLink.test.ts` holds the TypeScript port (`catalogLink.ts`) to every verdict.
 *
 * Regenerate:  KATA_EMIT_BORN_LINKED=1 ./tools/engine-tests/run.sh   (also after any catalogue re-export)
 * The harness gate `f15-2-born-linked` regenerates this in memory on every run and fails if it differs.
 *
 * Verdict: L<i>e tier 1 · L<i>a tier 2 · C<n>:<first three> candidates · N novel; <i> indexes CATALOG_ROWS.
 */
import type { CatalogRow } from "./catalogLink";

export const CATALOG_ROWS: readonly CatalogRow[] = [
  { id: "00b4127b-f010-410e-9f46-67b8ea59105b", name: "Wall HS (Stomach to Wall)" },
  { id: "01dfd01b-bd4c-4db6-b604-e343c8f80f61", name: "Wall HS" },
  { id: "03794f1e-027b-4bee-b103-d62fccc18b75", name: "Straight-Body One-Arm Pushup" },
  { id: "0475fd8b-86e0-4993-9813-074a6afe6511", name: "Rings-Turned-Out L-Sit" },
  { id: "04f32ee4-4cc6-425d-8330-c19bc66a4867", name: "Barbell Bent-Over Row" },
  { id: "05dbcfcb-3d9f-4dc7-9b58-a78cdacb4c0b", name: "Thoracic Rotation" },
  { id: "063fbfa5-da56-451b-a647-54c7c082d375", name: "Clapping Pushup – Slap Your Stomach" },
  { id: "0702bc12-4bdf-4884-a52b-b537cee7d323", name: "Shoulder Circles" },
  { id: "072929cd-6ca7-4241-8588-295a640f1292", name: "Back-to-Wall HS" },
  { id: "07a30bdc-ea87-4181-a1bb-00f68e7370d8", name: "Straddle Back Lever" },
  { id: "07a53289-fe1b-4ea9-8615-5790c65472fa", name: "P-Movement (LYTP Prone)" },
  { id: "0866981b-f206-4a39-88a8-cb3b43b41d84", name: "HSPU (Elbows Tucked)" },
  { id: "086b7b77-c3dc-4b2c-8243-3f6e1990f599", name: "One-Arm HS" },
  { id: "088e6908-ed07-44a3-8347-a374db66d768", name: "One-Arm Ab Wheel – Level 10" },
  { id: "0994f3ca-caff-464d-8379-4c2145a13719", name: "Iron Cross" },
  { id: "0a17af24-5a5e-4d89-bcf1-7f00b5571e3f", name: "One-Arm Bent-Over Row (Assistance for Muscle-Up Transition)" },
  { id: "0a3cd004-f237-4852-af7d-b150d8d3f896", name: "Static Stretch Hold" },
  { id: "0a59721a-f9e4-41a2-9ff6-8da91d0c0fa6", name: "Elevated Back Leg Lunge Stretch (Quad and Hip Flexor)" },
  { id: "0a868bb1-2857-457b-875d-c65d16fa6960", name: "Wall Push-Up" },
  { id: "0aa30e92-4368-4985-b236-514aeb9ba639", name: "Jumping Dips" },
  { id: "0af5da0a-24d8-41c6-ad8b-74d47aa3bfef", name: "Eccentric Dip Lowering" },
  { id: "0b2042ed-f0e3-4c6b-8f1b-0ee1aa7f6706", name: "Triceps Extension" },
  { id: "0b6a5dc7-fc82-4aa5-bd61-4e54494937bd", name: "Single-Leg Lunge" },
  { id: "0b8b3d7e-9cf9-454a-b8a7-653d98fa73e2", name: "One-Arm HS (Arm Lift Progression)" },
  { id: "0bab8a55-dfcb-47f5-b836-906a51c9634e", name: "Tuck Front Lever Pull-ups" },
  { id: "0bc401ec-9450-4ba6-9c79-a71613861874", name: "Regular Stretching (Static Stretching)" },
  { id: "0c5d43df-5535-4e2a-8205-3d49935c4c44", name: "Paired Hand/Wrist Stretch (Hands Together)" },
  { id: "0c6a916a-e143-48e0-bd0c-dd590b11a9c6", name: "Box Headstand Pushup" },
  { id: "0c959e08-a4c9-465d-9f0e-2d549cf0de6e", name: "Forward Roll (Ground)" },
  { id: "0ce34fac-0f6d-42e9-b96e-4831daf0a324", name: "Rings-Turned-Out 90 Degrees + 30-Degree Forward-Lean Dips" },
  { id: "0d29bb5e-1572-4fa1-8bab-ef9b26af2aa4", name: "Hanging Knee Raise" },
  { id: "0d2d4771-4719-416d-93b3-e227923606a6", name: "Hanging Leg Raises" },
  { id: "0d3667a7-a3b6-4fcf-94b5-9774f7a08506", name: "Candlestick" },
  { id: "0df8191f-321a-4bd4-87e2-9566fa97a56f", name: "Good Mornings" },
  { id: "0fd35a58-4092-49a4-8c9b-128dfb8d89a0", name: "One-Arm Dip" },
  { id: "0fe35e69-8f43-49e4-b8e3-278c7d490e69", name: "Front Lever Rows Progression" },
  { id: "10536e8b-3101-48ca-8917-7d4bce5e1a46", name: "Patellar Reflex Inhibition Stretch" },
  { id: "109ccb34-d9bf-42d7-82ce-aa312bb91885", name: "Wall Straddle Press to HS Eccentrics" },
  { id: "10ad61c2-65bc-452e-8c93-4f201ad5953d", name: "Spiderman Stretch" },
  { id: "113ce3d2-78c9-4c65-85bc-8f32560ebdd6", name: "Felge Forward to Cross (Straight-Arm)" },
  { id: "11ad0ca0-163b-4772-a48a-30dfef2cd084", name: "Butterfly Mount" },
  { id: "12aa81f5-77bd-47e8-b575-f739d5b78571", name: "Flag" },
  { id: "12cb8979-8aa0-4a54-9963-c6262301e354", name: "Front Lever Eccentric to Hang" },
  { id: "1365d9dd-7a7e-4b17-ba72-3b98a9aac8c7", name: "LYTP T-Movement (Prone Horizontal Arm Extension)" },
  { id: "1439da38-86cd-4dd3-9f70-e475ba78ebb3", name: "Rings-Turned-Out 45 Degrees Past Parallel Dips" },
  { id: "155de4a9-8282-426a-898f-6b2a5356be34", name: "Deep Step-ups" },
  { id: "15cb3ba8-937e-42fd-bcec-62bc54192c28", name: "Supine Dumbbell Front Raises" },
  { id: "161e1acb-42d4-4ac8-8c33-defb34b85749", name: "Reverse Plank" },
  { id: "163dc97f-689d-4e43-8b0e-90679d8d6d32", name: "Compression Flexibility Combo (Hamstring/Adductor Stretch with Active Compression)" },
  { id: "165ad970-39cb-4a5a-8cfa-2b4745560ace", name: "Rings Straddle Planche" },
  { id: "1688b6d6-164d-4dc8-b99d-d8c63ac3c493", name: "Wide Ring Rows" },
  { id: "16a8e6cb-1ded-4802-852c-bd9f62d4d89d", name: "Tuck Planche Pushups" },
  { id: "16aa5541-080d-43fd-a9f7-3841e1031664", name: "Chair HS" },
  { id: "16ae8c57-14da-4035-9b30-b758a4251bf5", name: "Rings-Turned-Out 90 Degrees Past Parallel Dips" },
  { id: "18184223-cca1-400a-ade1-3a8b626fa7e5", name: "Rings-Turned-Out Straddle L-Sit" },
  { id: "1883fb16-7df0-4988-a83e-46080f8195ce", name: "Half Layout Back Lever" },
  { id: "18ceee59-f5ce-49d5-a6cd-fcc55b126e49", name: "100-Degree V-Sit" },
  { id: "18ec820b-3aa9-4e07-afca-136affdb6b41", name: "Rings Strap HSPU" },
  { id: "1a098482-7b72-429c-b14e-c31cf4e5aa00", name: "Rings-Turned-Out Pushups" },
  { id: "1a730b6f-92ff-4979-a7d3-e895727818b2", name: "Straight-Arm Back Kip to Support" },
  { id: "1b1e014e-8bdf-4ec7-bd8f-9a010dc42045", name: "Decline Bicep Curl" },
  { id: "1b233ae4-b12b-40c1-b034-9145cba9e168", name: "Free HSPU" },
  { id: "1bb61c06-9321-4c34-a691-d4f441ee6100", name: "Finger Tap Drill (One-Arm HS Progression)" },
  { id: "1c92fc1d-11c9-49cd-a0cf-c427ab5377b9", name: "Clapping Pushup – Slap Your Chest" },
  { id: "1dd98f49-e034-4e6a-8238-dd9bcc48e333", name: "Bent-Arm, Bent-Body Press to HS (Pike Position)" },
  { id: "1e09ec13-db99-4de2-9986-84db09ec3a0c", name: "Cross Pulls with Feet on Block" },
  { id: "1e6f58bf-170d-4049-bb0f-682d27c780ca", name: "Hanging Leg Lifts (Level 4)" },
  { id: "1e8445af-3056-453b-93a8-3d8fbcbadcd5", name: "Ab Wheel + 20 lbs. – Level 9" },
  { id: "1ed2fe56-197c-4edb-b6fa-6e929dd6ec00", name: "Frog Stand" },
  { id: "1ff06268-e58a-4e22-8856-4a3e1467121a", name: "One-Arm HS — Head-Away Counterbalance Style" },
  { id: "20c1f9f1-e5d7-4fbf-aff5-5db9b07c37bf", name: "Natural Hamstring Curls" },
  { id: "20c3c996-6b4d-4a2d-bddb-6842f1ba4ed6", name: "Rings Bent-Arm, Bent-Body Press to HS (Support Position Variation)" },
  { id: "21bbb6ad-9dbf-4ecf-a369-40be836aaf6d", name: "Rings Straddle One-Arm Pushup" },
  { id: "227b62db-1d61-4311-b2a3-7f02f65bddff", name: "Pull to Inverted Hang" },
  { id: "23bebcc2-42db-44a5-afb6-0b765d33f61e", name: "HS Walking" },
  { id: "240c822e-34ca-46d2-9772-0728bb533469", name: "Negative Pull-Up" },
  { id: "240ecca4-42aa-485a-a680-25cca911d2f7", name: "Dip Straight-Body Press to HS" },
  { id: "24227c50-c591-4375-9419-a477ebf0ae65", name: "One-Leg-Out Planche" },
  { id: "24a786a0-dd2e-4b93-a3ab-ae520f67272f", name: "Individual Finger Lift Forearm Stretch" },
  { id: "24b6f300-20ef-4aa9-ab34-7c38d8cf0829", name: "Tuck Planche" },
  { id: "24de5b68-3968-4009-bfc5-28857341dd6d", name: "Rings Advanced Tuck Planche" },
  { id: "2516810a-6bcc-41a7-bdc2-a458132c4f28", name: "Elbow Lever" },
  { id: "25272310-641b-4ec2-b8fd-0e116181ebee", name: "One-Arm Chin (OAC)" },
  { id: "254635ab-fcac-4203-8c45-d1782fa7fbbe", name: "Scapular Pull-Up" },
  { id: "2671a8dd-7889-4248-8d01-9c536e863561", name: "Wrist Circles" },
  { id: "26b25bfb-5fe5-4d58-994a-611d2e9d6ac5", name: "Glute Ham Raise" },
  { id: "26f39317-49fd-4fe0-9cf2-8025256f06ca", name: "Crawling" },
  { id: "277cc3d5-eb1d-4360-a101-4d94e935ab01", name: "Wrist Stretching — Back of Palm on Ground, All Directions" },
  { id: "2901c9b4-30ea-406d-ba36-82311df9d3b5", name: "Straddle Front Lever Pull-ups" },
  { id: "294ebd73-cbd9-47a8-afd6-7e1c56400d33", name: "Straddle or Pike Stand, Press to HS" },
  { id: "29f8cfd6-47ed-4df0-976b-51a75ddcc104", name: "Kipping Clapping Pull-Ups" },
  { id: "2a02aa30-a15d-4db5-8677-75668f7eadaa", name: "Wall Headstand Pushup (Wall HeSPU)" },
  { id: "2a25db85-56f0-47fb-97de-78f6e2d4ce7b", name: "Flat Ground Calf Raises" },
  { id: "2a2e2e12-a4ad-413f-a5d4-c27998aab74c", name: "L-Sit, Slap-the-Thighs Pull-Ups" },
  { id: "2aabc91c-c6bc-407e-9766-6b85902976ad", name: "Weight Shift to One Arm (HS Drill)" },
  { id: "2ab6dcef-6811-4d22-a6b6-1615a851cbff", name: "Romanian Deadlift" },
  { id: "2af9ea18-2af9-47cf-b114-18d7d9620b69", name: "Scapular Retractions" },
  { id: "2b5cdbf8-16aa-45a4-906e-a7c68933c4d5", name: "Muscle-Up Negatives (MU Negatives)" },
  { id: "2bd47de8-2cbf-458b-8ca3-1c953d6aa78f", name: "Straddle Planche" },
  { id: "2cd4bbbd-c264-4982-b3a7-fc11c3c2241c", name: "Chair Step-ups" },
  { id: "2d20a728-3f7d-4bf1-a8d5-33fe6e8c41b6", name: "Crab Walk" },
  { id: "2e20415d-cc32-4d79-a660-9bda31da72f5", name: "Basketball Chest / Pectoralis Minor Roll" },
  { id: "2e216be6-eee7-42f3-ab63-e8819e0fb95b", name: "Overhead Band Slide-Out" },
  { id: "2f1e11e2-873d-4b34-9517-ccec3a1bf6ac", name: "PNF Contract-Relax Stretch" },
  { id: "2f43f82f-570d-4963-bf65-f9807c0f16a9", name: "Rings-Turned-Out 75 Degrees Past Parallel Dips" },
  { id: "2fce38a3-2439-4b02-8491-5008323fd473", name: "Planche Progression Pushups" },
  { id: "2fd3e51c-31ce-424d-8bee-095645221b29", name: "Inverted Row" },
  { id: "2fea0794-3d82-48eb-8233-b8937668a80e", name: "RTO Support" },
  { id: "30929ddd-acc5-4331-99eb-2955fe30c4a6", name: "Doorway Stretch" },
  { id: "31d5e112-4fe1-4b0f-9482-2d20e9e11268", name: "Side Bridges" },
  { id: "322db742-f38b-4e0b-a129-aa665e54db25", name: "Ab Wheel Rollout" },
  { id: "33735b78-7cb7-4fb2-9a5e-942ab01137fa", name: "HS with 4 Fingers (Level 6)" },
  { id: "33903811-e097-49e4-8f1d-334e3f8d1912", name: "Dumbbell Bench Press" },
  { id: "34034986-a5eb-4b28-a8ac-e37428815546", name: "Advanced Tuck Front Lever Row Rope Climb" },
  { id: "3534d49a-1769-427c-8011-654db6180c9b", name: "Advanced Tuck Front Lever Row" },
  { id: "3570aeb5-a218-447a-bb9c-bf57a10ff8b8", name: "Hamstring Curl (Machine)" },
  { id: "359b68fb-6356-4a17-8ad6-43d929328970", name: "Ring Dips" },
  { id: "35e5b233-fc8c-45ec-905c-dbb7868c49ed", name: "Illusion Chair HS" },
  { id: "363757a3-9f73-4c3c-a42f-4f88de0fbfec", name: "Rings-Turned-Out Maltese Pushups" },
  { id: "36dbb023-ff17-489e-8b44-a19e2db0d48e", name: "Straight-Arm Kip to L-Sit" },
  { id: "376da8c7-e1c1-4ab5-a167-0cc500870e40", name: "Straight-Arm Frog Stand" },
  { id: "3982f460-e901-4fea-821a-74c5fbb2b76f", name: "HSPU" },
  { id: "39baad3a-f072-48a3-83b6-0bd391a9db15", name: "Palm Pulse Wrist Drill" },
  { id: "3a0a86f9-a8f2-4f8f-b730-6fc9b8bbe7db", name: "Dead Hang" },
  { id: "3a4f7cd6-6c05-47d9-8f58-d959859ff149", name: "Advanced Tuck Planche with Ankle Weights" },
  { id: "3abe9b91-1cf1-4db4-a83c-7322ac007c04", name: "Ring Dips Progression" },
  { id: "3b4d7296-3b97-4608-8339-39edd0f99f8c", name: "Reverse Hypers" },
  { id: "3b68aff7-9ef4-4b29-bfc4-7cf3eedf7163", name: "Front Lever Pull to Inverted Hang" },
  { id: "3bd4c0bc-b99d-45dc-a063-525bb95eee2d", name: "One-Arm Weight Shift at Chest-to-Wall HS" },
  { id: "3be7652e-67e2-4234-99ec-0782210dab9d", name: "Straight-Arm Pike Press HS" },
  { id: "3c8c0532-94e5-4877-a434-7cb04b570263", name: "Rings Bent-Arm, Bent-Body Press to HS" },
  { id: "3cfe74d3-da8f-40a8-b7bc-ef49188939e7", name: "Burpee with Push-Up" },
  { id: "3e261110-5db6-4dcf-b187-8487bd203857", name: "Lunge to HS (Kick-Up)" },
  { id: "3e40fa89-20d5-4949-bc06-858bc46c4c9b", name: "Inverted Cross" },
  { id: "3efb72ab-d505-414f-ad4e-9cea3956c662", name: "Ab Wheel Eccentrics – Level 7" },
  { id: "3f6de360-eb66-4646-bb4f-0ed902e80035", name: "Wrist Roller" },
  { id: "3f9d46e6-e576-4da7-8b43-e6233ac9a083", name: "Pike Headstand Pushup" },
  { id: "3fe1fa7b-f44b-4969-9588-27f97e0a55b4", name: "One-Arm Chin-Up Isometric Holds" },
  { id: "4005c649-515b-4d04-bb6d-3cc7d375797e", name: "Planche Leans" },
  { id: "406c0f8b-c793-4a9c-9670-4f440dffdfd6", name: "Pendlay Row" },
  { id: "42469401-bb74-4a3f-845a-c98efdebb678", name: "Pushups" },
  { id: "4252f4d7-8fce-4937-80ea-36ba395b402d", name: "Rings Strap HSPU (With Elbows In)" },
  { id: "4351743d-7039-431e-8ccf-bd7bb88b1e5c", name: "Advanced Tuck Planche Pushup to Bottom Straddle Planche Pushup Position" },
  { id: "44e6d12a-1602-46cc-966f-8fd734fff957", name: "Cat-Cow" },
  { id: "45b279e8-d9de-4b6a-acd4-e35f928f850c", name: "German Hang Pullouts" },
  { id: "45e0e559-12b8-4ae6-a5ee-6801c778344e", name: "Ground Clapping Pushups" },
  { id: "4667c6d6-125f-4e8b-8125-9dddd87ca2c1", name: "Advanced Tuck Front Lever Pull-ups" },
  { id: "46b0347a-21f7-4838-9233-53d167f4df06", name: "Tuck FL Pull-ups" },
  { id: "475daa14-881a-4395-b853-7b1053c27bf7", name: "Theraband Cross Pulls (Level 3)" },
  { id: "47987e01-dd29-4e52-a3e4-55a7e3cc46f0", name: "Dips with Rings-Turned-Out (RTO)" },
  { id: "47b1bca8-bb3b-4783-bed0-9a0b8dc71024", name: "Forearm Rotation (Fist on Ground)" },
  { id: "47d9dd00-2977-4e4a-830f-3663dbc5a837", name: "Bulgarian Split Squat" },
  { id: "483b2c0b-be5c-4f1f-a827-ccace3982df9", name: "Dip" },
  { id: "48b0363e-8261-4bec-a559-2c07f461736a", name: "Support Hold" },
  { id: "48fc7d51-caa6-43b3-950b-663246f35c87", name: "Front Squat" },
  { id: "4930e890-658f-4847-9685-0195618fd0d9", name: "Half-Layout Planche" },
  { id: "4a808512-0baa-48bc-8643-ae7ba8eeb85f", name: "Back Bridge" },
  { id: "4b525e6e-f726-460f-a3d2-5c914b9206aa", name: "Ring Row Eccentrics – Level 1" },
  { id: "4bf92e5d-b6f8-469d-8041-fdd1563cd105", name: "Rings Straight-Arm Frog Stand" },
  { id: "4c4505eb-9508-49cd-8b99-14d43e1e05c1", name: "Sleeper Stretch" },
  { id: "4c5dc710-2f46-4250-98bb-07f9602fc8bd", name: "Straddle Front Lever Row Rope Climb" },
  { id: "4c79cb79-2f0f-4500-af38-ba4682b8210f", name: "Pike Push-Up" },
  { id: "4e13f275-5325-4ad0-a712-5336a3b2315a", name: "Full Squat" },
  { id: "4f2849c3-7031-4611-a551-2e5cbe20ab78", name: "Twisted Flag" },
  { id: "4f49655f-8570-47d8-a1a4-d59076415c3f", name: "Free HSPU (Parallettes)" },
  { id: "4f64f329-f432-40ed-aeaa-7f482706dce6", name: "Incline Push-Up" },
  { id: "504021cd-afab-429c-b5e0-4a8298ee299a", name: "Butterfly Mount (Straight-Arm Muscle-Up to Support)" },
  { id: "51152cfa-2912-4500-9ada-7ebae1e49ad7", name: "Straight-Arm Straight-Body Planche to HS" },
  { id: "51a81512-28c2-4404-8f46-8c56122c1d35", name: "Bear Walk" },
  { id: "51add5c5-33f3-4594-86a2-3e5fddc73e59", name: "Face Pull" },
  { id: "529331c4-3210-4fa2-a6f2-9706ee24de6a", name: "Scapular Protractions" },
  { id: "5338c31f-f7ae-4c6f-ae88-0cabd062f464", name: "Scapular Elevations" },
  { id: "5390f198-2a1f-40dc-b8b7-fc20e13bd135", name: "Rice Bucket Wrist Exercise" },
  { id: "5465d40e-9665-4d27-b7df-7cdceb74dab4", name: "Tuck L-Sit" },
  { id: "5469efbc-e6f0-453b-9655-8d2a05e84f7e", name: "Archer-Arm-In Ring Rows" },
  { id: "54a133b2-b6ae-49cd-b4b3-25a91c0e64c5", name: "Pseudo Planche Pushups (PPPU)" },
  { id: "553687c3-3f9b-4edc-b040-561a9ed8cf62", name: "Ring Push-ups" },
  { id: "55697ee9-9c92-4d3a-93ae-0d2203d8ee4f", name: "L-Sit (Advanced Leg Lift Variation)" },
  { id: "55cef72e-6e03-477c-916e-8ff7fae968a2", name: "Bench Press" },
  { id: "57c0e495-d7ee-45c9-970b-7775e7fa3c23", name: "Kipping Behind-the-Back Clapping Pull-Ups" },
  { id: "57e67b93-abce-40a4-afa4-74700bc737df", name: "Archer Rows (Level 6)" },
  { id: "58083832-0564-43ea-a087-b8852d2bec1b", name: "Planche Isometrics (Level 8)" },
  { id: "582f0698-2f55-4591-ad8c-2f42ec4d7226", name: "Seated Wrist Mobility Stretch" },
  { id: "5931e553-9faf-4758-af50-8d496ab635c2", name: "Tuck Planche (Straight-Arm Routine)" },
  { id: "5974f425-b725-4cb4-bb0f-f1a5ce7aa22f", name: "Vertical Flag" },
  { id: "59eee3df-b817-4d42-8216-26b6ae7e1a0d", name: "Squat Thrust" },
  { id: "5a55d66e-e627-403b-b030-622cd0dd48aa", name: "Jumping Pull-ups" },
  { id: "5c2392b3-611e-44b4-ad36-4aeae062bffb", name: "Knees Ab Wheel – Level 5" },
  { id: "5cddaa79-2d28-4d2d-8302-7caaece73a67", name: "Scapular Push-ups" },
  { id: "5ce7dc94-e704-4d98-9371-302bc2144645", name: "HS" },
  { id: "5d2d9197-e002-42ff-9691-8a4cd9302cb9", name: "V-Ups" },
  { id: "5d44da4a-e369-4405-b15a-95f0e9634ba9", name: "L-Sit" },
  { id: "5db26e16-0ae5-4915-b762-59787a9b0a5a", name: "Straight-Arm Press HS" },
  { id: "5deed899-241f-4115-93c6-0b634e8d9010", name: "Straddle One-Arm Pushup" },
  { id: "5e070017-b109-48d4-b7e2-5f4458b306d3", name: "LYTP Y-Movement (Prone Lower Trapezius Raise)" },
  { id: "5e1bf2cc-f3d8-4de2-ac5e-129c120eb1bc", name: "Rings Straight-Arm Straight-Body Press to HS" },
  { id: "5ec39f50-53d2-4b73-94b2-d7eee3d3dfd7", name: "Cable Cross Pulls" },
  { id: "5f28514a-dabc-4765-9a28-232a5a3d7c23", name: "HS to Elbow Lever to HS (HS, EL, HS)" },
  { id: "5f3476d3-631e-42e3-baa7-6817e015f6c4", name: "Wall HS Split-Foot Balance" },
  { id: "5fc01541-03b5-4bbf-aab0-02d899f9adaf", name: "Rings Two-Arm Elbow Lever" },
  { id: "5fe56830-522f-4245-8379-ba2ec6e9732a", name: "Planche Isometrics (Level 9)" },
  { id: "6029c39c-2124-44e7-b554-12db52a03a5a", name: "L-Sit / Straddle-L Straddle Press to HS" },
  { id: "60b8e07e-da23-448b-8dd4-7e5987b0d8fc", name: "Chest Roll Straight-Body Press to HS (CR SB Press)" },
  { id: "616bb219-acfa-4269-8090-2eb68decb26d", name: "Frenchies" },
  { id: "61b38144-9945-4f06-a748-1b48860fc148", name: "Straddle Flag" },
  { id: "61ef513e-0053-4462-9b7e-365ff8f7d476", name: "Clapping Pushup – Behind the Back" },
  { id: "62dded8c-c290-4ff5-bae4-a9471a445020", name: "Band-Assisted Pushup" },
  { id: "62e2ed83-0b4d-4c39-afad-2df100491964", name: "Block/Rack Pulls" },
  { id: "63506979-6ccd-4ca2-a2cf-8f34885c8f19", name: "Pulley-assisted One-Arm Chin-up (OAC)" },
  { id: "63e386c7-01cd-43f5-b6a6-ee580821c249", name: "Scapular Shrugs (Hang)" },
  { id: "649c8ca2-53ee-4993-b1cc-fb13e687e1e1", name: "Asian Squat" },
  { id: "653beaff-60fe-473b-bf9e-47b5e50a6fcb", name: "Front Lever Muscle-up to Planche Variation" },
  { id: "654d8a50-c8d6-40d8-93f0-3beb414e926b", name: "Pistol Squat" },
  { id: "6554dfdd-e7f1-4ac7-9bc7-0ba32bb85faf", name: "Free HS Shoulder Taps" },
  { id: "65778eef-ac46-4912-81af-9e0e60d259af", name: "L-Sit Clapping Pull-Ups" },
  { id: "6590bb1e-55bc-485b-84f9-e269caf8b389", name: "Wall HSPUs" },
  { id: "680ae618-e661-4af0-99d1-ddd6d9c79ed9", name: "Wrist Stretching — Palms Flat, All Directions" },
  { id: "6856489b-8666-4099-96c8-77301534001d", name: "Side-to-Side Squat Stretch" },
  { id: "685ea04e-6225-488f-ace6-45903ae6ecc2", name: "Back Lever" },
  { id: "691e3b87-210d-4201-a173-23073be24e0c", name: "Rings-Turned-Out 40-Degree-Lean Pseudo Planche Pushups" },
  { id: "6929694e-0b00-4c86-a789-1e75e323965c", name: "Rings Bent-Arm Straight-Body Press to HS (Hollowback Press)" },
  { id: "6a27e66f-75b0-493b-a998-36be0a0ae07f", name: "Half Layout Flag" },
  { id: "6ae84067-af4f-43ae-b0d9-1a5a2a59556e", name: "90-Degree RTO Dips" },
  { id: "6bd16308-eef4-4463-abe4-021eb297e5d3", name: "Ring Rows – Level 2" },
  { id: "6c3e8833-9494-495d-a041-3a61d859477c", name: "HS Roll-Out Bail" },
  { id: "6cc67819-3e22-4d00-8fb9-987ab9db7770", name: "Elevated Pushup (Assisted Concentric)" },
  { id: "6d209228-08f5-4846-ba49-297d364ecc05", name: "Skater Bounds" },
  { id: "6db2f906-8936-4119-b594-b63ac5ad4790", name: "Biceps Curl" },
  { id: "6ddcd9fd-5f42-4c3c-afce-2fa4b3a5c092", name: "Advanced Tuck FL Pull-ups" },
  { id: "6e8a1103-8f4f-43a8-8995-3d4132de5445", name: "Maltese Hold" },
  { id: "712276a1-7c68-48a2-bafd-26b360b7fc08", name: "90-Degree RTO Leaned-Forward Dips" },
  { id: "7244fa6f-431b-4e2a-b4bd-b574be50db33", name: "Overhead Press" },
  { id: "727962e7-d536-457e-874c-750e8717a26c", name: "Serratus Anterior and Lower Trap Isolation" },
  { id: "72c23833-5a0d-460d-890d-331a16b19854", name: "Archer Push-Up" },
  { id: "73d32db5-5929-4c94-925e-831f61d78889", name: "Deadlift with Bands or Chains" },
  { id: "753bb51c-9c40-4ebc-b400-398ccba63818", name: "Bent-Arm, Bent-Body Press to HS" },
  { id: "755bae7e-9094-429e-8ed8-f8ca2063eb8a", name: "Support Hold to Hang to Iron Cross" },
  { id: "75def7db-9aa8-4cdd-9b2d-16a8750351be", name: "Couch Stretch" },
  { id: "75f4150b-5cd8-4990-9ca1-0481ea9bff80", name: "Rings Wide HSPU" },
  { id: "76d9213a-7aba-427a-b374-c146441d71c6", name: "Straddle Straight-Arm Press to HS" },
  { id: "7723456d-e863-4145-acc6-f112cc24bb6e", name: "Tuck Front Lever Rows" },
  { id: "7789f85c-4963-4975-b2aa-3ed2369d0ece", name: "90/90 Hip Stretch" },
  { id: "794ae321-761f-48de-98e7-5118f575dca3", name: "Pseudo Planche Push-Ups (PPPU) with Planche Lean Pause" },
  { id: "794eb4d6-5bde-48d5-81c0-3c16ec3e204c", name: "One-Arm Rows" },
  { id: "79539256-e8da-45c1-910d-0989fc422bc3", name: "Chin-Up" },
  { id: "7a95a6b8-0e8a-45c9-9366-2a4fa9253e41", name: "Ramp Ab Wheel – Level 6" },
  { id: "7cfb8687-47b9-44b8-a4cc-f304354fe331", name: "Straight-Arm Straddle Press HS" },
  { id: "7d19a43f-13c2-4c20-b768-7101bb4bf7ee", name: "Tuck Front Lever" },
  { id: "7e03294c-a5c9-4fc4-b57c-2479b7d6471b", name: "Straddle L-Sit" },
  { id: "7e709228-f4f7-4a62-9460-1d6070dde7e6", name: "Side-to-Side Squat (Cossack Squat)" },
  { id: "80ac12a8-d8ba-4265-af5a-c1f920b8c0c4", name: "Leg Extension (Machine)" },
  { id: "80b9cc2e-3de1-46f8-9cea-45350d02471e", name: "Wall Headstand Pushup Eccentric" },
  { id: "815ef77f-ec90-498d-a326-43a07080e906", name: "One-Arm Weight Shift in Pushup Position" },
  { id: "82666879-ba57-4bbb-966c-f55d6fd47ec8", name: "L-Sit Pull-up Eccentrics" },
  { id: "83492dff-195d-460f-a544-b7a11a61558d", name: "Rings Bent-Arm, Straight-Body Press to HS" },
  { id: "83ead8ce-c080-4d35-8e74-1df4c0e91642", name: "Straddle One-Arm Rows" },
  { id: "8508c2a2-254a-4cdf-becd-defa3fd0c654", name: "Conventional Deadlift" },
  { id: "854d6e95-6bde-44cc-b89f-624f5a6076f3", name: "Shrimp Squat" },
  { id: "85c84235-17d9-43ca-b027-6f8fb19ccfbf", name: "Postural Alignment Check (Wall/Mirror Method)" },
  { id: "85cb584e-fffe-4fda-8ef6-8bb4f7b99a24", name: "HS with 3 Fingers (Level 7)" },
  { id: "85f9dca9-98eb-4211-bb71-9c05af6833ef", name: "Straddle Planche Pushup" },
  { id: "861a9b0b-0a04-4581-ba98-47b2056864e4", name: "Side Plank" },
  { id: "873f8a41-79de-44fd-8bba-e2beef99332d", name: "Deadlifts (Emphasized Concurrent)" },
  { id: "87d0d198-14f2-48a6-959e-56f4c9fed0f5", name: "Rings Straight-Arm Straddle Planche to HS" },
  { id: "87d61a29-5221-486b-8a23-21f4d7255e72", name: "Isolation Work for Muscle Strains (Repair Phase)" },
  { id: "88119a5b-d054-41f9-b8eb-a69f64691661", name: "One-Arm Straddle Elbow Lever" },
  { id: "886bf79b-af56-4485-b130-e46a1aa2e5e8", name: "Rings L-Sit Pull-ups" },
  { id: "889ef52a-4994-4ab1-a37c-072e1c160e66", name: "Shoulder Dislocates" },
  { id: "88c0f88a-1ebb-4603-a22a-9a5bf300b4b8", name: "Wall Slides" },
  { id: "88c61f8b-f2f9-41ab-8076-baffa7b9bb73", name: "Deep Squat Hold" },
  { id: "89d70618-1c69-4d0d-a3db-d94e4a35eff5", name: "L-Pull-up Eccentrics" },
  { id: "8b3bd11b-c709-430b-a51c-6965f1045988", name: "Diamond Push-Up" },
  { id: "8bae02ff-f724-4930-a292-bc7e36140958", name: "Horizontal Pulling / Rowing (Scapular Focus)" },
  { id: "8c863e4c-8a28-41c6-98d0-afaafc2af0af", name: "Bent-Arm Straight-Body Press to HS (BA SB Press)" },
  { id: "8c88cdc3-e6be-4897-be5b-c554799b9777", name: "German Hangs / Skin the Cat" },
  { id: "8d523656-f8ee-425c-af17-1e3bc1ecbaf8", name: "Scapular Pulls" },
  { id: "8d595bed-6510-4166-be98-913c02abc87a", name: "Smith Machine Planche Pushup" },
  { id: "8ec2923a-89f8-4859-85fb-984f52d3aec7", name: "Weighted Ring Dips" },
  { id: "8f6e9c7e-4181-418f-a5c5-2d44cc2fa2a1", name: "Lat Pulldown" },
  { id: "8ffe4904-fef2-49c7-84aa-26552f2fe46e", name: "Proprioceptive Neuromuscular Facilitation (PNF) Stretching" },
  { id: "90f0f8c4-7901-42e4-9560-2455f4967d2f", name: "Finger Mobilization (Single-Hand Ground Technique)" },
  { id: "90f3aa3b-9868-4b4e-b495-0dd0d4144558", name: "L-Pull-up" },
  { id: "9118fa8b-e80a-406e-bb17-3d16ffa8452f", name: "Straight-Arm Press Eccentrics / Elevated Straight-Arm Press" },
  { id: "9126e098-9b90-467f-888c-6f48dffb9176", name: "German Hang" },
  { id: "91372504-3120-4dc4-b00d-21837ccdb656", name: "High Holds with Eccentrics (Manna Progression)" },
  { id: "9174704f-d790-461e-9668-fcffb7e1e5d2", name: "Rings V-Sit" },
  { id: "92dcc0da-f4c5-42b6-8b03-58825c209186", name: "One-Arm Ring Row" },
  { id: "94eb4210-7f9a-413e-a81d-4f4e5e6373dc", name: "Cat-Camels" },
  { id: "96ac39be-5c99-4f22-856f-92da9afcfa19", name: "Hybrid Planche Set (Full to Straddle)" },
  { id: "96b162c5-d77f-4b16-afe3-645ef0c3c27e", name: "Rope Climbing" },
  { id: "96e98d35-ab41-42fd-b53d-5ef31010fa4d", name: "Advanced Tuck Front Lever (Straight-Arm Routine)" },
  { id: "980d0556-4185-4905-b4df-479203b27a05", name: "Band-Assisted Planche" },
  { id: "98334d84-37c8-430b-8a30-f008cd3c0990", name: "Pull Out of Back Lever Muscle-up to Press HS" },
  { id: "98872dbf-59e2-47b7-a100-0b32952cd6f9", name: "Tuck Flag" },
  { id: "988d7f75-5aa7-48c6-98e5-08a6319dd54c", name: "One-Arm Dip (Wall-Facing Variation)" },
  { id: "9b88f507-608a-4f7f-a323-0cbfc9c98b16", name: "Rings Straight-Arm Straight-Body Planche to HS" },
  { id: "9c6ac782-3e8e-41e8-bcb1-cd5352d4ddfd", name: "Thoracic Spine Foam Rolling" },
  { id: "9d1ee040-68aa-4345-a800-d2f058be3b34", name: "Chair Lunge" },
  { id: "9d9fa790-7f68-4ef5-b1d9-dbf29b8a1645", name: "Shoulder Blade Shrug with Pause (Elevation and Depression)" },
  { id: "9f241300-79bc-4bc2-ace1-68653259149d", name: "Rings Straight-Arm L-Sit Straddle Press to HS" },
  { id: "9fa24b2c-849b-4a81-897d-38130ddde4ae", name: "Palms-Down Finger Direction Wrist Stretch" },
  { id: "9fc7869c-0872-45f5-8406-759eccb4eba1", name: "Single-Leg RDL" },
  { id: "9fde48bd-9413-47c5-a0c0-7f76c79e65fa", name: "Tuck PL Pushups" },
  { id: "a025b6bb-3425-4625-9324-755dd06269fd", name: "Stair Step-ups" },
  { id: "a03c4da3-dfa5-48b8-8f32-951f62a6fa2e", name: "Crow Pose" },
  { id: "a0c4d355-0059-46fb-a424-7d9cb65c5a95", name: "Snatch Grip Deadlift" },
  { id: "a0edbb5d-641c-4c05-8daa-f62223e24180", name: "Back Lever Pullout" },
  { id: "a1037fec-0502-4782-8982-a0d9c10482b1", name: "Palms-Up Finger Direction Wrist Stretch" },
  { id: "a14960a3-bd9f-4d13-8abd-de3f164fab55", name: "Straddle Front Lever to Muscle-Up to Advanced Tuck Planche" },
  { id: "a1e030a6-6d7f-44ca-8038-5929bb41344d", name: "L-Sit Dips" },
  { id: "a2c950b6-8916-4359-a31a-1073dfd957e3", name: "Speed Pushes (Manna Progression)" },
  { id: "a2e25c85-2dd1-4dfd-821d-bdd336326424", name: "Rings-Turned-Out 60-Degree-Lean Pseudo Planche Pushups" },
  { id: "a3f4d7d8-be13-401c-a582-db9ae6157805", name: "L-Sit Bent-Arm, Bent-Body Press to HS" },
  { id: "a4114be1-bd2c-43af-8b39-5cdab27e478f", name: "Assisted Muscle-ups" },
  { id: "a4dcb4c0-a8e4-4069-9a6a-3dd9ddbc776f", name: "Back Kip to Support" },
  { id: "a58733bf-131e-4fcd-a9e7-005518162930", name: "Rings 90-Degree V-Sit" },
  { id: "a5f69bb5-e9df-4d2a-93be-cb3c150a272c", name: "Pullover" },
  { id: "a80176d8-e4af-4380-bd81-f727d1ac1e5b", name: "Plank" },
  { id: "a94f00b5-9b8e-4356-bbe5-2b793f172471", name: "Kettlebell Swing" },
  { id: "a9929f7f-25af-4ac1-a14c-b7272a53014b", name: "Bent-Arm, Bent-Body Press to HS (Straddle Position)" },
  { id: "a9c9f3cc-df51-410f-af5d-a4cf0bd31b5e", name: "Lat Foam Rolling" },
  { id: "abc6cb6a-398b-4944-b2de-82a284f516ac", name: "Foam Roll / Lacrosse Ball Thoracic Spine Extension" },
  { id: "ac6b77fe-fb7d-4622-a671-6eef4ea85d23", name: "Advanced Tuck Planche" },
  { id: "acfd8632-6d24-4e0a-bbe7-be4e30b48c18", name: "L-Sit / Straddle-L Pike Press to HS" },
  { id: "ad6f6d4b-c28b-473d-a20c-4e6ea518156a", name: "HS Shoulder Taps" },
  { id: "ad915b00-96a6-405b-9ac9-c0a9d7d474bd", name: "Archer Ring Rows" },
  { id: "addaad5d-8c3d-4c0f-9c61-8a4d5a0364b4", name: "One-Arm Chin-Up Assisted Pulley Concentrics" },
  { id: "aead48fc-7ac8-478f-8d19-d3744f15798f", name: "Rings Tuck Planche Pushups" },
  { id: "afbb6fee-ecdb-4d2b-b835-62268e08ea1b", name: "Rings Pushups" },
  { id: "b07a4c5b-c5b3-4f7c-b979-589d6522e722", name: "Half Layout Front Lever" },
  { id: "b09149ee-2add-45db-a307-903e68f16b30", name: "Pull-up to Advanced Tuck Front Lever Row Position" },
  { id: "b13d6fac-64ec-43ac-adff-f14e512f7e6f", name: "Glute Bridge" },
  { id: "b1dae90c-6431-451c-b32f-4084b8203483", name: "Dumbbell Planche Pushup" },
  { id: "b1e529f5-75a8-4451-8f8e-9fa53a8e5181", name: "Squat (Maintenance Volume)" },
  { id: "b27b8402-e064-4226-9ede-e8e40e7e6a56", name: "Lunge Hamstring Stretch" },
  { id: "b28df603-0a3c-4822-82d8-2c8fb108f61e", name: "Rings Strap HS" },
  { id: "b3285438-1716-4b37-a9d9-3c60113ffd0d", name: "Fingertip Support on Free Arm (One-Arm HS Progression)" },
  { id: "b3a651ef-fd7f-48c4-8a68-750bf0420e12", name: "One-Leg-Out Front Lever" },
  { id: "b3b56a3c-929c-4365-a455-99aa1ddd97cf", name: "Rings HS (R HS)" },
  { id: "b430a294-396d-4aa6-b7eb-6dc62524d4ef", name: "One-Arm Dip (Wall-Parallel Variation)" },
  { id: "b4ceb880-27a0-4adb-bb2d-38910dcb26b9", name: "Lower Trap Isolation" },
  { id: "b5d23954-c021-4f6d-8254-7650ad47e3ac", name: "Rings Tuck Planche" },
  { id: "b5e30f44-19c8-4f47-82d6-9aaf89676448", name: "Hang Pull to Inverted Hang" },
  { id: "b6e7bf0a-db4a-4741-bde4-d6232d3e4e2c", name: "Cross Pulls (Level 9)" },
  { id: "b7e05d71-69e5-4c6b-a324-0392b87971c7", name: "HSPU on Parallettes (Stomach to Wall)" },
  { id: "b8695ec7-e9ee-48d5-a735-f9c75fb0deb4", name: "Hang Pull to Front Lever" },
  { id: "ba8f7908-9f69-404d-ab05-b06d59bb63fa", name: "King Deadlift" },
  { id: "bb33a437-79b2-4258-945f-ecb2ee1cc782", name: "Triple Clapping Pushup" },
  { id: "bb7a8b3c-6575-4d8b-a478-ce6d97f07d82", name: "Compression Work" },
  { id: "bb9ae412-2227-4a9c-bff1-5e663bf8792d", name: "Split Hold" },
  { id: "bc3e807c-0362-4efe-8212-6e146f53ca2e", name: "Rings Dip Eccentrics" },
  { id: "bc8ca14d-28a6-4a34-9be9-3a337079b005", name: "Tuck Planche Roll Back to Back Lever" },
  { id: "bc8ee9d7-17be-4b18-83d5-5725156d882e", name: "Advanced Tuck Planche Push-up" },
  { id: "bf34c946-ef84-40bf-a8de-457df51a3467", name: "Band/Wall Shoulder Blade Retraction with Breathing" },
  { id: "bfe3c5ac-1e46-4ee2-a2c6-1b053698a0ce", name: "Rings-Turned-Out Archer Pushups" },
  { id: "c01e07da-c9d1-42c7-b939-c23af3bfd5c1", name: "Foam Roller / Ball Lat Stretch" },
  { id: "c0bc050e-e10a-4a1f-a3cf-f6d3245f7e89", name: "Archer Rows (Level 7)" },
  { id: "c0ccf4b9-d090-4804-a1f5-9e21b4c4a3e7", name: "Inverted Pull-ups" },
  { id: "c130bc50-08e0-47f7-bd6c-93415e8e5163", name: "Band Dislocates" },
  { id: "c15fb7f6-5de5-4e46-9737-81b0c2a589c0", name: "Straddle Front Lever" },
  { id: "c197e01f-7453-4a93-ae30-e09b0a0319c4", name: "Lunge" },
  { id: "c2d7a1ae-2906-4219-975e-b5e463234666", name: "Wall Pseudo Planche Pushups" },
  { id: "c2e52e63-fb33-4e26-a75c-dc6eca633900", name: "External Rotation Stretch" },
  { id: "c5d60619-e087-4229-aead-fb4782521466", name: "Good Mornings (for Hamstring Flexibility)" },
  { id: "c6564aae-9862-4273-8a1c-bf863a46983a", name: "Rings-Turned-Out (RTO) Support Hold" },
  { id: "c6a7ef44-6d59-4d79-9f3a-b818a17b73e9", name: "Weighted Decline Sit-Ups" },
  { id: "c8312751-0ac8-4fae-b219-eae70af7d028", name: "Rings Dip to HS" },
  { id: "c873dc09-7937-49d7-91bd-33fb8ec25b10", name: "Straddle Front Lever Row" },
  { id: "c9d2a1df-8862-48ff-8b57-4e60f211a85d", name: "Single-Leg Step Calf Raise" },
  { id: "c9ee5196-46a1-4c38-9a01-ad0a3e69471b", name: "Corner Stretch (Pectoralis Major)" },
  { id: "ca399198-8b7b-418a-9f96-43961f0c29fe", name: "Box Clapping Pushups" },
  { id: "cac01a4b-27ac-4785-8050-7062877e877f", name: "Front Lever Negatives" },
  { id: "cb73571a-f1bb-435a-91af-febe3387e458", name: "RTO L-Sit" },
  { id: "cba07457-4696-4e1b-a0de-be296567ff1c", name: "HS with 2 Fingers (Level 8)" },
  { id: "cbd589c6-f66c-4d00-a072-6d9ee3075596", name: "Weighted Dips" },
  { id: "ccf09613-1006-4e75-bb87-ba52ccdb5ebb", name: "Pseudo Planche Push-Ups (PPPUs) with Feet Elevated and Top Hold" },
  { id: "cde5367e-5583-4ca4-9b72-3a2943135b9e", name: "Straddle V-Sit (Floor)" },
  { id: "ceb62a1b-c7b9-47f2-9175-c6fe6621a343", name: "Wide Grip Pull-up" },
  { id: "cf623def-1b63-460e-a610-0bc5c897ff73", name: "Palm Pulse Finger Extension" },
  { id: "d00bfc16-fe88-49ad-98e2-c464810aab60", name: "False Grip Pull-ups" },
  { id: "d049da19-2044-4027-b20c-2f765c8b2854", name: "Dips (Emphasized Concurrent)" },
  { id: "d0d0126b-a5fb-4bf5-9c61-a645a08611ef", name: "False Grip" },
  { id: "d118b40a-d6dc-4a9b-bd3f-59989c32aae6", name: "Deficit Deadlift" },
  { id: "d17910c5-6a1c-4cda-9c6e-d6da6ae752e4", name: "Parallel Bar Dip Straight-Body Press to HS (PB Dip SB to HS)" },
  { id: "d19a88e2-4fdb-45b0-b696-b15b388bf223", name: "Straight-Body, Slap-the-Thighs Pull-Ups" },
  { id: "d1aabc12-bd9c-47cb-be13-4190cdb0b1cd", name: "Rings Shoulder Stand" },
  { id: "d23cf4a1-5938-4515-8511-6b7ceabe4b33", name: "Advanced Tuck Planche Eccentrics" },
  { id: "d357e318-7b1b-4da8-95b3-c98ecc77bef9", name: "Hollow Body Hold" },
  { id: "d38b4ef4-4082-492f-a661-b1d899466f04", name: "Loaded Stretching" },
  { id: "d3be010c-d53c-4931-ba69-45ae2bb41eee", name: "One-Leg-Out Flag" },
  { id: "d49ecf25-e2ee-465f-be00-59aee1c033a3", name: "Full Front Lever" },
  { id: "d50fd3e4-8279-4edd-a25b-234743794737", name: "HS with 1 Finger (Level 9)" },
  { id: "d51e4e36-572d-49a0-9315-20e680eeb111", name: "McKenzie Method Exercises" },
  { id: "d55108ba-c6d3-4ea4-b129-40eafb513b23", name: "One-Arm Straight-Body Elbow Lever" },
  { id: "d5ba0b80-021d-4d05-bf51-05904b3825e0", name: "Pull-ups" },
  { id: "d608b38a-dd8a-42ab-854e-b41b207d7259", name: "Arch Hold" },
  { id: "d65c27e6-5053-4ac1-ab9f-25edcd0ed77e", name: "Scapular Depressions" },
  { id: "d670bda6-751b-4110-bf0c-6c00be40f597", name: "Barbell Back Squat" },
  { id: "d7056ac5-8ad4-4faf-96d7-773c584a2f47", name: "Wide / No-False-Grip Muscle-Up" },
  { id: "d7593287-3062-47a5-b345-717000f98ddf", name: "One-Arm Dumbbell Rows" },
  { id: "d78b62bd-27f2-4c29-912b-8ab099abad98", name: "Ring HSPU" },
  { id: "d80074dc-2aac-4e32-8055-fa0921d9d07b", name: "Ring Rows" },
  { id: "d83761b2-835c-4530-bf18-005dac697826", name: "L-Sit Slap-the-Abdominals Pull-Ups" },
  { id: "d9232242-ddc7-4fd7-bf08-1f3f6893919b", name: "Advanced Tuck Front Lever" },
  { id: "da0fe5d5-5ed7-498a-8689-36141915bd30", name: "High-Bar Back Squat" },
  { id: "da8df9f9-aa4a-4911-bc84-bca402884a12", name: "Rings Support Hold" },
  { id: "db365225-053e-4aa1-9471-e5016141f1b7", name: "Straddle Hamstring Stretching" },
  { id: "dbf58c16-c473-4b22-82bb-eeb182d29d9c", name: "Rings Advanced Tuck Planche Pushups" },
  { id: "dcb140c8-af14-4000-b64b-e21813330615", name: "Wrist Pushups (Pre-Hab)" },
  { id: "dcf6a22f-03ff-46e1-b55f-8f5660f80e0c", name: "Planche" },
  { id: "dcf9de3c-b5d4-4cce-9229-fded2bf7f52c", name: "Posterior Capsule Stretch" },
  { id: "dd96e088-c923-4d5f-a9ac-a0f4d5b2245d", name: "Wide Muscle-Up" },
  { id: "de3910b1-e5f2-4ea2-acb0-9097e4f30813", name: "Pull-ups (Emphasized Concurrent)" },
  { id: "df21640e-5741-4827-9e8c-7ffc48aac58b", name: "Seal Stretch" },
  { id: "df5cce33-6256-4237-a0bb-6dcd05744904", name: "LYTP L-Movement (Prone Posterior Deltoid Row)" },
  { id: "e124793d-5bd8-4218-8cb7-020027396e2c", name: "Ring Muscle-Up" },
  { id: "e18abf31-ff4c-4942-ad16-0a44a6379318", name: "Rings L-Sit Dips" },
  { id: "e2d06d42-9aa7-4a68-ab8c-3d719fc5912d", name: "Bar Muscle-Up" },
  { id: "e364e9ea-d42f-4ec7-9d9c-b586f870ab9e", name: "Kipping Muscle-Up (Kipping MU)" },
  { id: "e37f9c0a-39d8-45a2-bf62-b67144d7c316", name: "L-Sit / V-Sit Manna Progression" },
  { id: "e480efde-84f6-41e1-b1fe-36f8b882e24a", name: "Squat Jumps" },
  { id: "e5b27885-3009-4a03-80cb-a4b6d923498a", name: "One-Arm Chin-Up Finger-Assisted Concentrics" },
  { id: "e5d7be88-be80-4707-b8a0-0a2a9b33f958", name: "Non-Kipping Clapping Pull-Ups" },
  { id: "e714e0fa-4c01-4f44-ad92-946914006dd7", name: "Turkish Get-Up" },
  { id: "e8155bd0-238e-45c0-988f-d077c0ce539c", name: "Hands-Close-Together HS" },
  { id: "e8ad8ad5-9422-4416-8332-76300ecf258d", name: "One-Arm HS — Ear-to-Shoulder Shift Style" },
  { id: "e8bcce0e-74a2-4a68-9be5-89e630f6a787", name: "Hang to Front Lever Row" },
  { id: "e8bf21b2-5c6e-4c8e-9825-d0c9bbd7f923", name: "Straddle Stretch" },
  { id: "e933ea02-bd92-4685-9b21-b044b6bf88f9", name: "Strict Muscle-up" },
  { id: "ea9c58c5-ffe3-4d7d-9ce4-c2aa05533d8e", name: "Full Ab Wheel – Level 8" },
  { id: "eaa608ab-8386-480d-9bef-acd277bd6196", name: "Calf Raises (Posterior Tibialis)" },
  { id: "ead41939-f78f-4356-a04d-bcea536e2d7d", name: "Planche Isometrics (Level 10)" },
  { id: "eb7d26e6-b2f1-440d-895e-160e0ed58e0d", name: "Press HS from Seated Position" },
  { id: "eb9b286d-ce7b-486d-8da4-2910e1759b9b", name: "Asian Squat Loaded Hold" },
  { id: "eb9dd7f6-00eb-4b1b-b643-0af607fd2bf7", name: "Rings Frog Stand" },
  { id: "ebe6b850-74b7-488e-a7b3-a50d5e044bdc", name: "Hanging Leg Lifts (Level 5)" },
  { id: "ec25d6a1-6ae1-4610-b9ac-9f5c03c50c8e", name: "Romanian Deadlift (for Hamstring Flexibility)" },
  { id: "ed2160b0-1001-4b94-9dab-ab1c62f507f7", name: "Pistol Squats with Dumbbell" },
  { id: "ed86390d-594c-4714-98c6-b6a3f2c0bec1", name: "Individual Finger Mobilisation" },
  { id: "edaaaeb4-f1f2-4af5-a50e-5d44daf57bcb", name: "Loaded Toe Touch" },
  { id: "ee2bbbda-e41b-4d48-b3aa-3b37f6108d1a", name: "Straight Leg Deadlift" },
  { id: "ef0b267f-ad78-47fe-a74d-e2f421b11bb7", name: "Tuck Front Lever Row Rope Climb" },
  { id: "efd4f3a3-dea7-4078-9a1e-2e968237bd2f", name: "Planche Lean (Feet Elevated)" },
  { id: "f03aa0dd-9d60-4b1b-912c-86f2dde4a9d4", name: "Serratus Anterior Isolation" },
  { id: "f085f208-c124-4b24-a2bf-76b39f6d912d", name: "Goblet Squat" },
  { id: "f0f5830f-ea3f-4cbf-8567-cb8182456627", name: "Full Front Lever Pull-ups" },
  { id: "f102c8a4-2aae-4896-8f34-a3c6f5400024", name: "Front Lever Muscle-up to Tuck Planche" },
  { id: "f1389c25-b1ed-4633-9f09-88252f3fdd15", name: "Deep Breathing" },
  { id: "f25ae9b4-b858-46e0-b408-5c7acc3d1430", name: "Freestanding Headstand Pushup (Free HeSPU)" },
  { id: "f2bbe9dc-b17a-487f-a619-cac9aa0e0008", name: "Theraband Cross Pulls (Level 8)" },
  { id: "f300e62a-f8e5-4819-9653-a383a83a0c39", name: "Front Lever Pull-up" },
  { id: "f34f3584-6f4f-4f74-957e-94586af74124", name: "Hip Thrust" },
  { id: "f3f8685e-df95-42d4-a880-a5d2af2e059d", name: "Dumbbell Shoulder Press" },
  { id: "f47a22c8-2207-447a-9b1a-f0101e798703", name: "Straight-Arm Dumbbell Rotation (Pre-Hab)" },
  { id: "f60d41a3-7850-4093-916b-16432b8a6eb4", name: "Splits (Left and Right)" },
  { id: "f67bc5d0-d4d5-4d1d-8b0c-f61504b506f8", name: "Full Front Lever Rows" },
  { id: "f6ab8aa7-f42d-4a81-9f9f-3f0f4ab31711", name: "Dumbbell Finger Curls (Pre-Hab)" },
  { id: "f6f00d27-c2b9-4df9-9c9e-498acdc49e4e", name: "Elevator / Inverted Muscle-Up to HS" },
  { id: "f79a16d4-39fe-4616-a58b-7c32b9bfbe49", name: "Bird-Dogs" },
  { id: "f7c7029c-9358-4f7b-8fe6-76f3a2943dfa", name: "Wide Ring Rows – Level 3" },
  { id: "f7e65071-2c87-4b3d-a624-4c271a5561e4", name: "L-Sit Muscle-Up" },
  { id: "f7fb9243-9239-4df8-b45e-e175515cade2", name: "Burpees" },
  { id: "fa917073-6833-4e6a-b881-7c994859c447", name: "Tuck Jumps" },
  { id: "fac85a01-81db-4610-8080-1184c967b450", name: "45-Degree Forward-Lean Dips" },
  { id: "fb497cc1-f7cd-46b5-abb3-1bac824ad764", name: "Rings Straight-Body One-Arm Pushup" },
  { id: "fba1b463-3da7-4431-a7fd-11baa04005be", name: "Felge Backward Straight-Body to Support" },
  { id: "fbab6cb3-ca09-4804-9a85-6f519a269e4a", name: "Gymkana Beginner Routine (Rings)" },
  { id: "fbcec278-532c-485c-b018-bbbe972cec9b", name: "Shoulder Stand on Parallel Bars / Parallettes" },
  { id: "fcbc5239-b21d-41f8-b91d-207da4c0f2cc", name: "Dragon Flags" },
  { id: "fd107f92-5766-4c75-a851-eec47cac9fe8", name: "90-degree Rings-Turned-Out (RTO) Dips" },
  { id: "fe0bde9c-edca-4817-a660-ca5e9dc92915", name: "Cambered Hand Grip HS" },
  { id: "ff389511-23e1-42e9-a728-f25a53a14361", name: "One-Arm Chin-up (Eccentric)" },
  { id: "fff435d8-8555-49c7-8fc3-40f06ed02e16", name: "Bodyweight Squat" },
];

export const CATALOG_CORPUS: readonly (readonly [string, string])[] = [
  ["Ring Row", "L401e"],
  ["Ring Rows", "L401e"],
  ["Pull-Up", "L394e"],
  ["Pull-ups", "L394e"],
  ["Pullup", "L394e"],
  ["Deadlift", "C9:346,382,95"],
  ["Back Squat", "C2:397,404"],
  ["DB Row", "C1:399"],
  ["DB Curl", "N"],
  ["KB Swing", "L318a"],
  ["HSPU", "L121e"],
  ["Wall HSPU", "L215e"],
  ["Wall HSPUs", "L215e"],
  ["Flag", "L41e"],
  ["Dragon Flags", "L468e"],
  ["Push‑Up", "L140e"],
  ["  front squat  ", "L154e"],
  ["FRONT SQUAT", "L154e"],
  ["Hanging Leg Raise", "L31e"],
  ["Press", "C33:178,231,348"],
  ["Cross", "C10:14,133,196"],
  ["Mid-Dip Isometric Hold", "C1:152"],
  ["Assisted Full Planche (Pulley)", "C1:409"],
  ["Cossack Squat", "C1:249"],
  ["Ring Row, Feet Elevated", "C1:401"],
  ["Incline DB Press", "N"],
  ["Ring Dip", "L116e"],
  ["Cat / Camel", "L287e"],
  ["Farmer's Carry", "N"],
  ["Échappé", "N"],
  ["x", "C16:21,370,27"],
  ["", "N"],
  ["Tuck Planche Push-Up", "L51e"],
  ["Weighted Ring Dip", "L277e"],
  ["Scapular Push-Up", "L188e"],
  ["Planche Lean", "L138e"],
  ["Front Squat", "L154e"],
  ["Goblet Squat", "L444e"],
  ["Bodyweight Squat", "L472e"],
  ["Bulgarian Split Squat", "L151e"],
  ["Walking Lunge", "C1:360"],
  ["Step-Up", "C3:45,99,303"],
  ["Romanian Deadlift", "L95e"],
  ["Hip Thrust", "L451e"],
  ["Glute Bridge", "L331e"],
  ["Back Extension", "N"],
  ["Bench Press", "L178e"],
  ["DB Bench Press", "L112a"],
  ["Push-Up", "L140e"],
  ["Dip", "L152e"],
  ["Overhead Press", "L231e"],
  ["DB Shoulder Press", "L452a"],
  ["Lateral Raise", "N"],
  ["Chin-Up", "L244e"],
  ["Lat Pulldown", "L278e"],
  ["Barbell Row", "N"],
  ["Seated Cable Row", "N"],
  ["Inverted Row", "L106e"],
  ["Face Pull", "L169e"],
  ["Barbell Curl", "N"],
  ["Triceps Pushdown", "N"],
  ["Skull Crusher", "N"],
  ["Plank", "L317e"],
  ["Side Plank", "L261e"],
  ["Hollow Body Hold", "L387e"],
  ["Ab Wheel Rollout", "L110e"],
  ["Dead Bug", "N"],
  ["Standing Calf Raise", "N"],
  ["Jump Rope", "N"],
  ["Wall HS (Stomach to Wall)", "L0e"],
  ["Wall HS", "L1e"],
  ["Straight-Body One-Arm Pushup", "L2e"],
  ["Rings-Turned-Out L-Sit", "L3e"],
  ["Barbell Bent-Over Row", "L4e"],
  ["Thoracic Rotation", "L5e"],
  ["Clapping Pushup – Slap Your Stomach", "L6e"],
  ["Shoulder Circles", "L7e"],
  ["Back-to-Wall HS", "L8e"],
  ["Straddle Back Lever", "L9e"],
  ["P-Movement (LYTP Prone)", "L10e"],
  ["HSPU (Elbows Tucked)", "L11e"],
  ["One-Arm HS", "L12e"],
  ["One-Arm Ab Wheel – Level 10", "L13e"],
  ["Iron Cross", "L14e"],
  ["One-Arm Bent-Over Row (Assistance for Muscle-Up Transition)", "L15e"],
  ["Static Stretch Hold", "L16e"],
  ["Elevated Back Leg Lunge Stretch (Quad and Hip Flexor)", "L17e"],
  ["Wall Push-Up", "L18e"],
  ["Jumping Dips", "L19e"],
  ["Eccentric Dip Lowering", "L20e"],
  ["Triceps Extension", "L21e"],
  ["Single-Leg Lunge", "L22e"],
  ["One-Arm HS (Arm Lift Progression)", "L23e"],
  ["Tuck Front Lever Pull-ups", "L24e"],
  ["Regular Stretching (Static Stretching)", "L25e"],
  ["Paired Hand/Wrist Stretch (Hands Together)", "L26e"],
  ["Box Headstand Pushup", "L27e"],
  ["Forward Roll (Ground)", "L28e"],
  ["Rings-Turned-Out 90 Degrees + 30-Degree Forward-Lean Dips", "L29e"],
  ["Hanging Knee Raise", "L30e"],
  ["Hanging Leg Raises", "L31e"],
  ["Candlestick", "L32e"],
  ["Good Mornings", "L33e"],
  ["One-Arm Dip", "L34e"],
  ["Front Lever Rows Progression", "L35e"],
  ["Patellar Reflex Inhibition Stretch", "L36e"],
  ["Wall Straddle Press to HS Eccentrics", "L37e"],
  ["Spiderman Stretch", "L38e"],
  ["Felge Forward to Cross (Straight-Arm)", "L39e"],
  ["Butterfly Mount", "L40e"],
  ["Front Lever Eccentric to Hang", "L42e"],
  ["LYTP T-Movement (Prone Horizontal Arm Extension)", "L43e"],
  ["Rings-Turned-Out 45 Degrees Past Parallel Dips", "L44e"],
  ["Deep Step-ups", "L45e"],
  ["Supine Dumbbell Front Raises", "L46e"],
  ["Reverse Plank", "L47e"],
  ["Compression Flexibility Combo (Hamstring/Adductor Stretch with Active Compression)", "L48e"],
  ["Rings Straddle Planche", "L49e"],
  ["Wide Ring Rows", "L50e"],
  ["Tuck Planche Pushups", "L51e"],
  ["Chair HS", "L52e"],
  ["Rings-Turned-Out 90 Degrees Past Parallel Dips", "L53e"],
  ["Rings-Turned-Out Straddle L-Sit", "L54e"],
  ["Half Layout Back Lever", "L55e"],
  ["100-Degree V-Sit", "L56e"],
  ["Rings Strap HSPU", "L57e"],
  ["Rings-Turned-Out Pushups", "L58e"],
  ["Straight-Arm Back Kip to Support", "L59e"],
  ["Decline Bicep Curl", "L60e"],
  ["Free HSPU", "L61e"],
  ["Finger Tap Drill (One-Arm HS Progression)", "L62e"],
  ["Clapping Pushup – Slap Your Chest", "L63e"],
  ["Bent-Arm, Bent-Body Press to HS (Pike Position)", "L64e"],
  ["Cross Pulls with Feet on Block", "L65e"],
  ["Hanging Leg Lifts (Level 4)", "L66e"],
  ["Ab Wheel + 20 lbs. – Level 9", "L67e"],
  ["Frog Stand", "L68e"],
  ["One-Arm HS — Head-Away Counterbalance Style", "L69e"],
  ["Natural Hamstring Curls", "L70e"],
  ["Rings Bent-Arm, Bent-Body Press to HS (Support Position Variation)", "L71e"],
  ["Rings Straddle One-Arm Pushup", "L72e"],
  ["Pull to Inverted Hang", "L73e"],
  ["HS Walking", "L74e"],
  ["Negative Pull-Up", "L75e"],
  ["Dip Straight-Body Press to HS", "L76e"],
  ["One-Leg-Out Planche", "L77e"],
  ["Individual Finger Lift Forearm Stretch", "L78e"],
  ["Tuck Planche", "L79e"],
  ["Rings Advanced Tuck Planche", "L80e"],
  ["Elbow Lever", "L81e"],
  ["One-Arm Chin (OAC)", "L82e"],
  ["Scapular Pull-Up", "L83e"],
  ["Wrist Circles", "L84e"],
  ["Glute Ham Raise", "L85e"],
  ["Crawling", "L86e"],
  ["Wrist Stretching — Back of Palm on Ground, All Directions", "L87e"],
  ["Straddle Front Lever Pull-ups", "L88e"],
  ["Straddle or Pike Stand, Press to HS", "L89e"],
  ["Kipping Clapping Pull-Ups", "L90e"],
  ["Wall Headstand Pushup (Wall HeSPU)", "L91e"],
  ["Flat Ground Calf Raises", "L92e"],
  ["L-Sit, Slap-the-Thighs Pull-Ups", "L93e"],
  ["Weight Shift to One Arm (HS Drill)", "L94e"],
  ["Scapular Retractions", "L96e"],
  ["Muscle-Up Negatives (MU Negatives)", "L97e"],
  ["Straddle Planche", "L98e"],
  ["Chair Step-ups", "L99e"],
  ["Crab Walk", "L100e"],
  ["Basketball Chest / Pectoralis Minor Roll", "L101e"],
  ["Overhead Band Slide-Out", "L102e"],
  ["PNF Contract-Relax Stretch", "L103e"],
  ["Rings-Turned-Out 75 Degrees Past Parallel Dips", "L104e"],
  ["Planche Progression Pushups", "L105e"],
  ["RTO Support", "L107e"],
  ["Doorway Stretch", "L108e"],
  ["Side Bridges", "L109e"],
  ["HS with 4 Fingers (Level 6)", "L111e"],
  ["Dumbbell Bench Press", "L112e"],
  ["Advanced Tuck Front Lever Row Rope Climb", "L113e"],
  ["Advanced Tuck Front Lever Row", "L114e"],
  ["Hamstring Curl (Machine)", "L115e"],
  ["Ring Dips", "L116e"],
  ["Illusion Chair HS", "L117e"],
  ["Rings-Turned-Out Maltese Pushups", "L118e"],
  ["Straight-Arm Kip to L-Sit", "L119e"],
  ["Straight-Arm Frog Stand", "L120e"],
  ["Palm Pulse Wrist Drill", "L122e"],
  ["Dead Hang", "L123e"],
  ["Advanced Tuck Planche with Ankle Weights", "L124e"],
  ["Ring Dips Progression", "L125e"],
  ["Reverse Hypers", "L126e"],
  ["Front Lever Pull to Inverted Hang", "L127e"],
  ["One-Arm Weight Shift at Chest-to-Wall HS", "L128e"],
  ["Straight-Arm Pike Press HS", "L129e"],
  ["Rings Bent-Arm, Bent-Body Press to HS", "L130e"],
  ["Burpee with Push-Up", "L131e"],
  ["Lunge to HS (Kick-Up)", "L132e"],
  ["Inverted Cross", "L133e"],
  ["Ab Wheel Eccentrics – Level 7", "L134e"],
  ["Wrist Roller", "L135e"],
  ["Pike Headstand Pushup", "L136e"],
  ["One-Arm Chin-Up Isometric Holds", "L137e"],
  ["Planche Leans", "L138e"],
  ["Pendlay Row", "L139e"],
  ["Pushups", "L140e"],
  ["Rings Strap HSPU (With Elbows In)", "L141e"],
  ["Advanced Tuck Planche Pushup to Bottom Straddle Planche Pushup Position", "L142e"],
  ["Cat-Cow", "L143e"],
  ["German Hang Pullouts", "L144e"],
  ["Ground Clapping Pushups", "L145e"],
  ["Advanced Tuck Front Lever Pull-ups", "L146e"],
  ["Tuck FL Pull-ups", "L147e"],
  ["Theraband Cross Pulls (Level 3)", "L148e"],
  ["Dips with Rings-Turned-Out (RTO)", "L149e"],
  ["Forearm Rotation (Fist on Ground)", "L150e"],
  ["Support Hold", "L153e"],
  ["Half-Layout Planche", "L155e"],
  ["Back Bridge", "L156e"],
  ["Ring Row Eccentrics – Level 1", "L157e"],
  ["Rings Straight-Arm Frog Stand", "L158e"],
  ["Sleeper Stretch", "L159e"],
  ["Straddle Front Lever Row Rope Climb", "L160e"],
  ["Pike Push-Up", "L161e"],
  ["Full Squat", "L162e"],
  ["Twisted Flag", "L163e"],
  ["Free HSPU (Parallettes)", "L164e"],
  ["Incline Push-Up", "L165e"],
  ["Butterfly Mount (Straight-Arm Muscle-Up to Support)", "L166e"],
  ["Straight-Arm Straight-Body Planche to HS", "L167e"],
  ["Bear Walk", "L168e"],
  ["Scapular Protractions", "L170e"],
  ["Scapular Elevations", "L171e"],
  ["Rice Bucket Wrist Exercise", "L172e"],
  ["Tuck L-Sit", "L173e"],
  ["Archer-Arm-In Ring Rows", "L174e"],
  ["Pseudo Planche Pushups (PPPU)", "L175e"],
  ["Ring Push-ups", "L176e"],
  ["L-Sit (Advanced Leg Lift Variation)", "L177e"],
  ["Kipping Behind-the-Back Clapping Pull-Ups", "L179e"],
  ["Archer Rows (Level 6)", "L180e"],
  ["Planche Isometrics (Level 8)", "L181e"],
  ["Seated Wrist Mobility Stretch", "L182e"],
  ["Tuck Planche (Straight-Arm Routine)", "L183e"],
  ["Vertical Flag", "L184e"],
  ["Squat Thrust", "L185e"],
  ["Jumping Pull-ups", "L186e"],
  ["Knees Ab Wheel – Level 5", "L187e"],
  ["Scapular Push-ups", "L188e"],
  ["HS", "L189e"],
  ["V-Ups", "L190e"],
  ["L-Sit", "L191e"],
  ["Straight-Arm Press HS", "L192e"],
  ["Straddle One-Arm Pushup", "L193e"],
  ["LYTP Y-Movement (Prone Lower Trapezius Raise)", "L194e"],
  ["Rings Straight-Arm Straight-Body Press to HS", "L195e"],
  ["Cable Cross Pulls", "L196e"],
  ["HS to Elbow Lever to HS (HS, EL, HS)", "L197e"],
  ["Wall HS Split-Foot Balance", "L198e"],
  ["Rings Two-Arm Elbow Lever", "L199e"],
  ["Planche Isometrics (Level 9)", "L200e"],
  ["L-Sit / Straddle-L Straddle Press to HS", "L201e"],
  ["Chest Roll Straight-Body Press to HS (CR SB Press)", "L202e"],
  ["Frenchies", "L203e"],
  ["Straddle Flag", "L204e"],
  ["Clapping Pushup – Behind the Back", "L205e"],
  ["Band-Assisted Pushup", "L206e"],
  ["Block/Rack Pulls", "L207e"],
  ["Pulley-assisted One-Arm Chin-up (OAC)", "L208e"],
  ["Scapular Shrugs (Hang)", "L209e"],
  ["Asian Squat", "L210e"],
  ["Front Lever Muscle-up to Planche Variation", "L211e"],
  ["Pistol Squat", "L212e"],
  ["Free HS Shoulder Taps", "L213e"],
  ["L-Sit Clapping Pull-Ups", "L214e"],
  ["Wrist Stretching — Palms Flat, All Directions", "L216e"],
  ["Side-to-Side Squat Stretch", "L217e"],
  ["Back Lever", "L218e"],
  ["Rings-Turned-Out 40-Degree-Lean Pseudo Planche Pushups", "L219e"],
  ["Rings Bent-Arm Straight-Body Press to HS (Hollowback Press)", "L220e"],
  ["Half Layout Flag", "L221e"],
  ["90-Degree RTO Dips", "L222e"],
  ["Ring Rows – Level 2", "L223e"],
  ["HS Roll-Out Bail", "L224e"],
  ["Elevated Pushup (Assisted Concentric)", "L225e"],
  ["Skater Bounds", "L226e"],
  ["Biceps Curl", "L227e"],
  ["Advanced Tuck FL Pull-ups", "L228e"],
  ["Maltese Hold", "L229e"],
  ["90-Degree RTO Leaned-Forward Dips", "L230e"],
  ["Serratus Anterior and Lower Trap Isolation", "L232e"],
  ["Archer Push-Up", "L233e"],
  ["Deadlift with Bands or Chains", "L234e"],
  ["Bent-Arm, Bent-Body Press to HS", "L235e"],
  ["Support Hold to Hang to Iron Cross", "L236e"],
  ["Couch Stretch", "L237e"],
  ["Rings Wide HSPU", "L238e"],
  ["Straddle Straight-Arm Press to HS", "L239e"],
  ["Tuck Front Lever Rows", "L240e"],
  ["90/90 Hip Stretch", "L241e"],
  ["Pseudo Planche Push-Ups (PPPU) with Planche Lean Pause", "L242e"],
  ["One-Arm Rows", "L243e"],
  ["Ramp Ab Wheel – Level 6", "L245e"],
  ["Straight-Arm Straddle Press HS", "L246e"],
  ["Tuck Front Lever", "L247e"],
  ["Straddle L-Sit", "L248e"],
  ["Side-to-Side Squat (Cossack Squat)", "L249e"],
  ["Leg Extension (Machine)", "L250e"],
  ["Wall Headstand Pushup Eccentric", "L251e"],
  ["One-Arm Weight Shift in Pushup Position", "L252e"],
  ["L-Sit Pull-up Eccentrics", "L253e"],
  ["Rings Bent-Arm, Straight-Body Press to HS", "L254e"],
  ["Straddle One-Arm Rows", "L255e"],
  ["Conventional Deadlift", "L256e"],
  ["Shrimp Squat", "L257e"],
  ["Postural Alignment Check (Wall/Mirror Method)", "L258e"],
  ["HS with 3 Fingers (Level 7)", "L259e"],
  ["Straddle Planche Pushup", "L260e"],
  ["Deadlifts (Emphasized Concurrent)", "L262e"],
  ["Rings Straight-Arm Straddle Planche to HS", "L263e"],
  ["Isolation Work for Muscle Strains (Repair Phase)", "L264e"],
  ["One-Arm Straddle Elbow Lever", "L265e"],
  ["Rings L-Sit Pull-ups", "L266e"],
  ["Shoulder Dislocates", "L267e"],
  ["Wall Slides", "L268e"],
  ["Deep Squat Hold", "L269e"],
  ["L-Pull-up Eccentrics", "L270e"],
  ["Diamond Push-Up", "L271e"],
  ["Horizontal Pulling / Rowing (Scapular Focus)", "L272e"],
  ["Bent-Arm Straight-Body Press to HS (BA SB Press)", "L273e"],
  ["German Hangs / Skin the Cat", "L274e"],
  ["Scapular Pulls", "L275e"],
  ["Smith Machine Planche Pushup", "L276e"],
  ["Weighted Ring Dips", "L277e"],
  ["Proprioceptive Neuromuscular Facilitation (PNF) Stretching", "L279e"],
  ["Finger Mobilization (Single-Hand Ground Technique)", "L280e"],
  ["L-Pull-up", "L281e"],
  ["Straight-Arm Press Eccentrics / Elevated Straight-Arm Press", "L282e"],
  ["German Hang", "L283e"],
  ["High Holds with Eccentrics (Manna Progression)", "L284e"],
  ["Rings V-Sit", "L285e"],
  ["One-Arm Ring Row", "L286e"],
  ["Cat-Camels", "L287e"],
  ["Hybrid Planche Set (Full to Straddle)", "L288e"],
  ["Rope Climbing", "L289e"],
  ["Advanced Tuck Front Lever (Straight-Arm Routine)", "L290e"],
  ["Band-Assisted Planche", "L291e"],
  ["Pull Out of Back Lever Muscle-up to Press HS", "L292e"],
  ["Tuck Flag", "L293e"],
  ["One-Arm Dip (Wall-Facing Variation)", "L294e"],
  ["Rings Straight-Arm Straight-Body Planche to HS", "L295e"],
  ["Thoracic Spine Foam Rolling", "L296e"],
  ["Chair Lunge", "L297e"],
  ["Shoulder Blade Shrug with Pause (Elevation and Depression)", "L298e"],
  ["Rings Straight-Arm L-Sit Straddle Press to HS", "L299e"],
  ["Palms-Down Finger Direction Wrist Stretch", "L300e"],
  ["Single-Leg RDL", "L301e"],
  ["Tuck PL Pushups", "L302e"],
  ["Stair Step-ups", "L303e"],
  ["Crow Pose", "L304e"],
  ["Snatch Grip Deadlift", "L305e"],
  ["Back Lever Pullout", "L306e"],
  ["Palms-Up Finger Direction Wrist Stretch", "L307e"],
  ["Straddle Front Lever to Muscle-Up to Advanced Tuck Planche", "L308e"],
  ["L-Sit Dips", "L309e"],
  ["Speed Pushes (Manna Progression)", "L310e"],
  ["Rings-Turned-Out 60-Degree-Lean Pseudo Planche Pushups", "L311e"],
  ["L-Sit Bent-Arm, Bent-Body Press to HS", "L312e"],
  ["Assisted Muscle-ups", "L313e"],
  ["Back Kip to Support", "L314e"],
  ["Rings 90-Degree V-Sit", "L315e"],
  ["Pullover", "L316e"],
  ["Kettlebell Swing", "L318e"],
  ["Bent-Arm, Bent-Body Press to HS (Straddle Position)", "L319e"],
  ["Lat Foam Rolling", "L320e"],
  ["Foam Roll / Lacrosse Ball Thoracic Spine Extension", "L321e"],
  ["Advanced Tuck Planche", "L322e"],
  ["L-Sit / Straddle-L Pike Press to HS", "L323e"],
  ["HS Shoulder Taps", "L324e"],
  ["Archer Ring Rows", "L325e"],
  ["One-Arm Chin-Up Assisted Pulley Concentrics", "L326e"],
  ["Rings Tuck Planche Pushups", "L327e"],
  ["Rings Pushups", "L328e"],
  ["Half Layout Front Lever", "L329e"],
  ["Pull-up to Advanced Tuck Front Lever Row Position", "L330e"],
  ["Dumbbell Planche Pushup", "L332e"],
  ["Squat (Maintenance Volume)", "L333e"],
  ["Lunge Hamstring Stretch", "L334e"],
  ["Rings Strap HS", "L335e"],
  ["Fingertip Support on Free Arm (One-Arm HS Progression)", "L336e"],
  ["One-Leg-Out Front Lever", "L337e"],
  ["Rings HS (R HS)", "L338e"],
  ["One-Arm Dip (Wall-Parallel Variation)", "L339e"],
  ["Lower Trap Isolation", "L340e"],
  ["Rings Tuck Planche", "L341e"],
  ["Hang Pull to Inverted Hang", "L342e"],
  ["Cross Pulls (Level 9)", "L343e"],
  ["HSPU on Parallettes (Stomach to Wall)", "L344e"],
  ["Hang Pull to Front Lever", "L345e"],
  ["King Deadlift", "L346e"],
  ["Triple Clapping Pushup", "L347e"],
  ["Compression Work", "L348e"],
  ["Split Hold", "L349e"],
  ["Rings Dip Eccentrics", "L350e"],
  ["Tuck Planche Roll Back to Back Lever", "L351e"],
  ["Advanced Tuck Planche Push-up", "L352e"],
  ["Band/Wall Shoulder Blade Retraction with Breathing", "L353e"],
  ["Rings-Turned-Out Archer Pushups", "L354e"],
  ["Foam Roller / Ball Lat Stretch", "L355e"],
  ["Archer Rows (Level 7)", "L356e"],
  ["Inverted Pull-ups", "L357e"],
  ["Band Dislocates", "L358e"],
  ["Straddle Front Lever", "L359e"],
  ["Lunge", "L360e"],
  ["Wall Pseudo Planche Pushups", "L361e"],
  ["External Rotation Stretch", "L362e"],
  ["Good Mornings (for Hamstring Flexibility)", "L363e"],
  ["Rings-Turned-Out (RTO) Support Hold", "L364e"],
  ["Weighted Decline Sit-Ups", "L365e"],
  ["Rings Dip to HS", "L366e"],
  ["Straddle Front Lever Row", "L367e"],
  ["Single-Leg Step Calf Raise", "L368e"],
  ["Corner Stretch (Pectoralis Major)", "L369e"],
  ["Box Clapping Pushups", "L370e"],
  ["Front Lever Negatives", "L371e"],
  ["RTO L-Sit", "L372e"],
  ["HS with 2 Fingers (Level 8)", "L373e"],
  ["Weighted Dips", "L374e"],
  ["Pseudo Planche Push-Ups (PPPUs) with Feet Elevated and Top Hold", "L375e"],
  ["Straddle V-Sit (Floor)", "L376e"],
  ["Wide Grip Pull-up", "L377e"],
  ["Palm Pulse Finger Extension", "L378e"],
  ["False Grip Pull-ups", "L379e"],
  ["Dips (Emphasized Concurrent)", "L380e"],
  ["False Grip", "L381e"],
  ["Deficit Deadlift", "L382e"],
  ["Parallel Bar Dip Straight-Body Press to HS (PB Dip SB to HS)", "L383e"],
  ["Straight-Body, Slap-the-Thighs Pull-Ups", "L384e"],
  ["Rings Shoulder Stand", "L385e"],
  ["Advanced Tuck Planche Eccentrics", "L386e"],
  ["Loaded Stretching", "L388e"],
  ["One-Leg-Out Flag", "L389e"],
  ["Full Front Lever", "L390e"],
  ["HS with 1 Finger (Level 9)", "L391e"],
  ["McKenzie Method Exercises", "L392e"],
  ["One-Arm Straight-Body Elbow Lever", "L393e"],
  ["Arch Hold", "L395e"],
  ["Scapular Depressions", "L396e"],
  ["Barbell Back Squat", "L397e"],
  ["Wide / No-False-Grip Muscle-Up", "L398e"],
  ["One-Arm Dumbbell Rows", "L399e"],
  ["Ring HSPU", "L400e"],
  ["L-Sit Slap-the-Abdominals Pull-Ups", "L402e"],
  ["Advanced Tuck Front Lever", "L403e"],
  ["High-Bar Back Squat", "L404e"],
  ["Rings Support Hold", "L405e"],
  ["Straddle Hamstring Stretching", "L406e"],
  ["Rings Advanced Tuck Planche Pushups", "L407e"],
  ["Wrist Pushups (Pre-Hab)", "L408e"],
  ["Planche", "L409e"],
  ["Posterior Capsule Stretch", "L410e"],
  ["Wide Muscle-Up", "L411e"],
  ["Pull-ups (Emphasized Concurrent)", "L412e"],
  ["Seal Stretch", "L413e"],
  ["LYTP L-Movement (Prone Posterior Deltoid Row)", "L414e"],
  ["Ring Muscle-Up", "L415e"],
  ["Rings L-Sit Dips", "L416e"],
  ["Bar Muscle-Up", "L417e"],
  ["Kipping Muscle-Up (Kipping MU)", "L418e"],
  ["L-Sit / V-Sit Manna Progression", "L419e"],
  ["Squat Jumps", "L420e"],
  ["One-Arm Chin-Up Finger-Assisted Concentrics", "L421e"],
  ["Non-Kipping Clapping Pull-Ups", "L422e"],
  ["Turkish Get-Up", "L423e"],
  ["Hands-Close-Together HS", "L424e"],
  ["One-Arm HS — Ear-to-Shoulder Shift Style", "L425e"],
  ["Hang to Front Lever Row", "L426e"],
  ["Straddle Stretch", "L427e"],
  ["Strict Muscle-up", "L428e"],
  ["Full Ab Wheel – Level 8", "L429e"],
  ["Calf Raises (Posterior Tibialis)", "L430e"],
  ["Planche Isometrics (Level 10)", "L431e"],
  ["Press HS from Seated Position", "L432e"],
  ["Asian Squat Loaded Hold", "L433e"],
  ["Rings Frog Stand", "L434e"],
  ["Hanging Leg Lifts (Level 5)", "L435e"],
  ["Romanian Deadlift (for Hamstring Flexibility)", "L436e"],
  ["Pistol Squats with Dumbbell", "L437e"],
  ["Individual Finger Mobilisation", "L438e"],
  ["Loaded Toe Touch", "L439e"],
  ["Straight Leg Deadlift", "L440e"],
  ["Tuck Front Lever Row Rope Climb", "L441e"],
  ["Planche Lean (Feet Elevated)", "L442e"],
  ["Serratus Anterior Isolation", "L443e"],
  ["Full Front Lever Pull-ups", "L445e"],
  ["Front Lever Muscle-up to Tuck Planche", "L446e"],
  ["Deep Breathing", "L447e"],
  ["Freestanding Headstand Pushup (Free HeSPU)", "L448e"],
  ["Theraband Cross Pulls (Level 8)", "L449e"],
  ["Front Lever Pull-up", "L450e"],
  ["Dumbbell Shoulder Press", "L452e"],
  ["Straight-Arm Dumbbell Rotation (Pre-Hab)", "L453e"],
  ["Splits (Left and Right)", "L454e"],
  ["Full Front Lever Rows", "L455e"],
  ["Dumbbell Finger Curls (Pre-Hab)", "L456e"],
  ["Elevator / Inverted Muscle-Up to HS", "L457e"],
  ["Bird-Dogs", "L458e"],
  ["Wide Ring Rows – Level 3", "L459e"],
  ["L-Sit Muscle-Up", "L460e"],
  ["Burpees", "L461e"],
  ["Tuck Jumps", "L462e"],
  ["45-Degree Forward-Lean Dips", "L463e"],
  ["Rings Straight-Body One-Arm Pushup", "L464e"],
  ["Felge Backward Straight-Body to Support", "L465e"],
  ["Gymkana Beginner Routine (Rings)", "L466e"],
  ["Shoulder Stand on Parallel Bars / Parallettes", "L467e"],
  ["90-degree Rings-Turned-Out (RTO) Dips", "L469e"],
  ["Cambered Hand Grip HS", "L470e"],
  ["One-Arm Chin-up (Eccentric)", "L471e"],
];
